<footer class="h-10 bg-pmdf-bg-card border-t border-pmdf-border-subtle px-pmdf-4 flex items-center justify-between text-[11px] text-pmdf-text-secondary">
  <div class="flex items-center gap-2">
    <strong class="font-bold text-pmdf-primary">SGP-PM</strong>
    <span class="opacity-70">v2026.1.0</span>
  </div>

  <div class="flex items-center gap-4">
    <div class="flex items-center gap-1.5">
      <div class="w-2 h-2 rounded-full bg-pmdf-success animate-pulse"></div>
      <span class="uppercase font-semibold tracking-wider">Online</span>
    </div>
    <span class="opacity-50">|</span>
    <span class="tabular-nums">{{ currentYear() }} PMDF</span>
  </div>
</footer>
